interface Measurement {
  name: string;
  measurement_type: string;
  data_type: string;
  target: number;
  base_line: number;
  frequency: string;
  project_id: number;
  department_id: number;
  technical_area_id: number;
}

interface ChangeIdea {
  name: string;
  project_id: number;
  project_cycle_id: number;
  id: number;
  measurements: Measurement[];
  is_selected: boolean;
}

export interface ProjectData {
  name: string;
  project_start_date: string;
  aim_statement: string;
  technical_area_id: number;
  facility_id: number;
  department_id: number;
  change_ideas: ChangeIdea[];
  change_ideas_ids: number[];
}

export interface ProjectState {
  data: ProjectData[];
  error: string | null;
}

export interface Action {
  type: string;
  payload: any;
}

const initialState: ProjectState = {
  data: [],
  error: null,
};

export const projectReducer = (
  state: ProjectState = initialState,
  action: Action
): ProjectState => {
  switch (action.type) {
    case "GET_PROJECT_SUCCESS":
      return { ...state, data: action.payload };
    case "GET_PROJECT_ERROR":
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
